import * as React from "react";

export interface SearchBarProps {
  value: string;
  placeholder: string;
  onChange: (value) => void;
  onFocus?: () => any;
  onBlur?: () => any;
  className?: string;
  icon?: string;
}

export default class SearchBar extends React.PureComponent<SearchBarProps> {
  static defaultProps = {
    className: "",
    icon: "ic_search",
  };

  render() {
    return (
      <div className={`search-bar h-flex ${this.props.className}`}>
        <i className={this.props.icon} />
        <input
          type="text"
          placeholder={this.props.placeholder}
          onChange={(event) => {
            const value = event.target.value;
            this.props.onChange(value);
          }}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          value={this.props.value}
        />
        {this.props.value && (
          <i className="ic_close clickable" onClick={() => this.props.onChange("")} />
        )}
      </div>
    );
  }
}
